import { useDataValue, useDataChange } from 'Simple/Data.js'

export function useOnChange(props) {
  let referral_templates = useDataValue({
    context: 'referral_templates',
    viewPath: props.viewPath,
  })
  let change = useDataChange({
    context: 'referral',
    viewPath: props.viewPath,
  })
  let referral_index = useDataValue({
    context: 'referral_item',
    viewPath: props.viewPath,
    path: 'index',
  })

  return function onChange(value) {
    let referral = referral_templates.find(t => t.id === value)
    change({
      ...referral,
      id: `${referral.id}-${referral_index}`,
      template: { ...referral },
      ...(referral.type === 'DropDown' && {
        selected_index: null,
      }),
      ...(referral.type === 'FreeText' && { text_value: '' }),
      ...(referral.type === 'Search' && { person: undefined }),
    })
  }
}
